import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AppShell from '../layouts/AppShell';
import V2ScrollToTop from '../layouts/V2ScrollToTop';
import RequireAuth from '../layouts/RequireAuth';
import Landing from '../pages/Landing';
import Auth from '../pages/Auth';
import DeleteAccount from '../pages/DeleteAccount';
import Catalog from '../pages/Catalog';
import Categories from '../pages/Categories';
import ProductDetail from '../pages/ProductDetail';
import Cart from '../pages/Cart';
import Checkout from '../pages/Checkout';
import CheckoutSummary from '../pages/CheckoutSummary';
import CheckoutPay from '../pages/CheckoutPay';
import OrderStatus from '../pages/OrderStatus';
import Account from '../pages/Account';
import MyAddresses from '../pages/MyAddresses';
import OrderDetails from '../pages/OrderDetails';
import LocationPage from '../pages/LocationPage';
import Coupon from '../pages/Coupon';
import ContactUs from '../pages/ContactUs';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import RefundPolicy from '../pages/RefundPolicy';
import Stores from '../pages/Stores';
import KnowYourChicken from '../pages/KnowYourChicken';
import Blogs from '../pages/Blogs';
import BlogPost from '../pages/BlogPost';
import NotFound from '../pages/NotFound';

export default function V2Routes() {
  return (
    <AppShell>
      <V2ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/categories/:slug" element={<Catalog />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route
          path="/checkout/summary"
          element={
            <RequireAuth>
              <CheckoutSummary />
            </RequireAuth>
          }
        />
        <Route
          path="/checkout/pay"
          element={
            <RequireAuth>
              <CheckoutPay />
            </RequireAuth>
          }
        />
        <Route
          path="/order-status"
          element={
            <RequireAuth>
              <OrderStatus />
            </RequireAuth>
          }
        />
        <Route
          path="/checkout"
          element={
            <RequireAuth>
              <Checkout />
            </RequireAuth>
          }
        />
        <Route
          path="/account/orders/:orderId"
          element={
            <RequireAuth>
              <OrderDetails />
            </RequireAuth>
          }
        />
        <Route
          path="/account"
          element={
            <RequireAuth>
              <Account />
            </RequireAuth>
          }
        />
        <Route
          path="/account/addresses"
          element={
            <RequireAuth>
              <MyAddresses />
            </RequireAuth>
          }
        />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/coupon" element={<Coupon />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/know-your-chicken" element={<KnowYourChicken />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:urlId" element={<BlogPost />} />
        <Route path="/termsAndConditions" element={<TermsAndConditions />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/refundPolicy" element={<RefundPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppShell>
  );
}
